// extracted by mini-css-extract-plugin
export default {"departments":"DG-z","departmentHeading":"EG-z","departmentSection":"FG-z","departmentName":"GG-z","departmentLink":"HG-z","expandIcon":"IG-z"};